import { jsx } from 'react/jsx-runtime';
import { rgba } from 'polished';
import styled, { keyframes, css } from 'styled-components';
import { px2rem } from '../../helpers/rem.mjs';
import { MEDIA_QUERY } from '../../constants/responsive.mjs';
import { parseRatio } from '../../helpers/ratio.mjs';

var shimmerKeyframes = keyframes(["from{transform:translateX(-100%);}to{transform:translateX(100%);}"]);
var SkeletonBoxBaseWrapper = styled.div.withConfig({
  displayName: "SkeletonBoxBaseWrapper",
  componentId: "sc-pvrz3w-0"
})(["position:relative;"]);
var SkeletonBoxShimmer = styled.div.withConfig({
  displayName: "SkeletonBoxShimmer",
  componentId: "sc-pvrz3w-1"
})(["@media ", "{position:absolute;top:0;right:0;bottom:0;left:0;transform:skewX(-45deg);&::after{position:absolute;top:0;right:0;bottom:0;left:0;background-image:linear-gradient( 90deg,", " 0,", " 20%,", " 60%,", " );animation:", " 2s infinite;content:\"\";}}"], MEDIA_QUERY.EXCEPT_MOBILE, function (props) {
  return rgba(props.theme.colorV2.colorSet.white1000, 0);
}, function (props) {
  return rgba(props.theme.colorV2.colorSet.white1000, 0.2);
}, function (props) {
  return rgba(props.theme.colorV2.colorSet.white1000, 0.5);
}, function (props) {
  return rgba(props.theme.colorV2.colorSet.white1000, 0);
}, shimmerKeyframes);
var SkeletonBoxBase = function SkeletonBoxBase(_ref) {
  var className = _ref.className;
  return jsx(SkeletonBoxBaseWrapper, {
    className: className,
    children: jsx(SkeletonBoxShimmer, {})
  });
};
var SkeletonBox = styled(SkeletonBoxBase).withConfig({
  displayName: "SkeletonBox",
  componentId: "sc-pvrz3w-2"
})(["width:", ";height:", ";border-radius:", ";", ";display:inline-block;position:relative;overflow:hidden;background-color:", ";"], function (props) {
  var _a;
  return (_a = props.width) !== null && _a !== void 0 ? _a : "100%";
}, function (props) {
  var _a;
  return (_a = props.height) !== null && _a !== void 0 ? _a : "100%";
}, px2rem(4), function (props) {
  return props.overrideStyle;
}, function (props) {
  return props.theme.colorV2.colorSet.grey50;
});
var SkeletonRatioBox = styled(SkeletonBoxBase).withConfig({
  displayName: "SkeletonRatioBox",
  componentId: "sc-pvrz3w-3"
})(["width:", ";height:0;padding-top:", "%;border-radius:", ";display:inline-block;position:relative;overflow:hidden;background-color:", ";"], function (props) {
  var _a;
  return (_a = props.width) !== null && _a !== void 0 ? _a : "100%";
}, function (props) {
  var _parseRatio = parseRatio(props.ratio),
    width = _parseRatio.width,
    height = _parseRatio.height;
  return Math.round(100 * (height / width));
}, px2rem(4), function (props) {
  return props.theme.colorV2.colorSet.grey50;
});
var SkeletonCircleBox = styled(SkeletonBox).attrs(function (props) {
  return {
    width: props.size,
    height: props.size
  };
}).withConfig({
  displayName: "SkeletonCircleBox",
  componentId: "sc-pvrz3w-4"
})(["border-radius:50%;"]);
var SkeletonRadiusBox = styled(SkeletonBox).withConfig({
  displayName: "SkeletonRadiusBox",
  componentId: "sc-pvrz3w-5"
})(["border-radius:", ";"], function (props) {
  return props.radius;
});
var FlexWrapper = styled.div.withConfig({
  displayName: "FlexWrapper",
  componentId: "sc-pvrz3w-6"
})(["display:flex;", ";", ";", ";"], function (props) {
  return props.flexDirection && css(["flex-direction:", ";"], props.flexDirection);
}, function (props) {
  return props.justifyContent && css(["justify-content:", ";"], props.justifyContent);
}, function (props) {
  return props.alignItems && css(["align-items:", ";"], props.alignItems);
});

export { FlexWrapper, SkeletonBox, SkeletonCircleBox, SkeletonRadiusBox, SkeletonRatioBox };
